import React from 'react';
import { useJoyride } from 'react-joyride';

import { ButtonBase } from '@material-ui/core';

import { useAuthDataContext } from 'components/AuthDataProvider/AuthDataProvider';
import ExtraTouchOnboardingTooltip from 'components/CampaignSteps/ExtraTouchOnboardingTooltip';
import useExtraTouchOnboarding from 'components/CampaignSteps/useExtraTouchOnboarding';
import useTourAppearance from 'components/GuidedTour/useTourAppearance';

const AccountExtraTouchOnboarding = ({ cancelButtonClassName, onAddOneNow }) => {
  const appearance = useTourAppearance();
  const {
    shouldAutoStartTour,
    handleJoyrideCallback,
    joyrideSteps,
    hasSaveError,
    retrySave,
  } = useExtraTouchOnboarding({ onAddOneNow });
  const { Tour } = useJoyride({
    ...appearance,
    steps: joyrideSteps,
    run: shouldAutoStartTour,
    continuous: false,
    tooltipComponent: ExtraTouchOnboardingTooltip,
    onEvent: handleJoyrideCallback,
    options: {
      ...appearance.options,
      skipScroll: true,
      showProgress: false,
      targetWaitTimeout: 3000,
    },
  });

  return (
    <>
      {Tour}
      {hasSaveError && (
        <div role="alert">
          We couldn’t save your extra-touch tutorial progress.
          {' '}
          <ButtonBase onClick={retrySave} className={cancelButtonClassName}>Retry saving</ButtonBase>
        </div>
      )}
    </>
  );
};

const ExtraTouchOnboarding = ({ isEnabled, ...props }) => {
  const auth = useAuthDataContext();
  if (!isEnabled || !auth?.isAuthLoaded || !auth.isAnyAgent || !auth.user?.id || auth.user.isAssumedUser) return null;
  return <AccountExtraTouchOnboarding key={auth.user.id} {...props} />;
};

export default ExtraTouchOnboarding;
